// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const logistics = {
  id: "logistics",
  title: "Logistics",
  type: "group",
  children: [
    {
      id: "logistics",
      title: "Packages",
      type: "item",
      url: "/logistics",
    },
  ],
};

export default logistics;
